import { render, staticRenderFns } from "./expResult.vue?vue&type=template&id=35921a6d&scoped=true"
import script from "./expResult.vue?vue&type=script&lang=js"
export * from "./expResult.vue?vue&type=script&lang=js"
import style0 from "./expResult.vue?vue&type=style&index=0&id=35921a6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35921a6d",
  null
  
)

export default component.exports